import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import rectangle from '../Images/Rectangle1.png'
import rectangl from '../Images/Rectangle2.png'
import rectang from '../Images/Rectangle3.png'
import { useNavigate } from "react-router-dom";


const Hero = () => {

    const navigate = useNavigate();

    const background = {
        background: '#EEEE',
    }

    return(
        <>
            <Carousel indicators={false} controls={true} interval={3000} fade>
            
            <Carousel.Item>
              <div style={background}>
                <div className="container">
                  <div className="row align-items-center  pb-5">
                    
                    <div className="top col-md-6">
                      <h5 className="inno">Innovation First</h5>
                      <h1 className="build mt-5">
                        <span style={{ color: '#353995' }}>Building Tomorrow’s</span> Digital Foundations <span style={{ color: '#353995' }}>Today.</span>
                      </h1>
                      <p className="high mt-4">
                        High-performance digital products for forward-thinking enterprises. We design, build, and scale technology that lasts.
                      </p>
                      <div className="d-flex gap-3">           
                        <button className="butt text-center w-500" onClick={() => navigate("/contact")}>Get In Touch</button>  
                        <button className="butts text-center w-500" onClick={() => navigate("/portfolio")}>View Portfolio</button>               
                      </div>
                      <p className="mt-5" style={{color: '#353995', fontSize: '15px' }}>Trusted by 50+ global enterprises</p>
                    </div>

                    <div className="col-md-6">
                      <img className="img-fluid mt-5" src={rectangle} alt="slide 1" />
                    </div>

                  </div>
                </div>
              </div>
            </Carousel.Item>


            <Carousel.Item>
              <div style={background}>
                <div className="container">
                  <div className="row align-items-center pb-5">

                    <div className="top col-md-6">
                      <h5 className="inno">AI-Driven Excellence</h5>
                      <h1 className="build mt-3">
                        <span style={{color: '#353995'}}>Where</span> <br />Technology, Intelligence, <span style={{color: '#353995'}}>and</span> Scale <span style={{color: '#353995'}}>Converge.</span>
                      </h1>
                      <p className="high mt-4">
                        Chilicom Technologies builds scalable platforms, AI-powered systems, and digital products engineered for performance, security, and long-term growth.
                      </p>
                      <div className="d-flex gap-3">
                        <button className="butt" onClick={() => navigate("/start-project")}>Start a Project</button>
                        <button className="butts" onClick={() => navigate("/portfolio")}>See our Work</button>
                      </div>
                      <p className="mt-5" style={{color: '#353995', fontSize: '15px' }}>Powering high-growth companies with future-ready technology.</p>
                    </div>

                    <div className="col-md-6">
                      <img className="img-fluid mt-5" src={rectangl} alt="slide 2" />
                    </div>

                  </div>
                </div>
              </div>
            </Carousel.Item>

            <Carousel.Item>
              <div style={background}>
                <div className="container">
                  <div className="row align-items-center pb-5">

                    <div className="top col-md-6">
                      <h3 className="inno">Digital Transformation</h3>
                      <h1 className="build mt-3">
                        <span style={{color: '#353995'}}>Transforming </span>Complex Challenges <span style={{color: '#353995'}}>into </span>Scalable Solutions.
                      </h1>
                      <p className="high mt-4">
                        From concept to launch, we deliver world-class digital products.
                      </p>
                      <div className="d-flex gap-3">
                        <button className="butt" onClick={() => navigate("/contact")}>Get in Touch</button>
                        <button className="butts" onClick={() => navigate("/portfolio")}>View Portfolio</button>
                      </div>
                      <p className="mt-5" style={{color: '#353995', fontSize: '15px' }}>Built for performance. Designed for impact. Trusted globally.</p>
                    </div>

                    <div className="col-md-6">
                      <img className="img-fluid" src={rectang} alt="slide 3" />
                    </div>

                  </div>
                </div>
              </div>
            </Carousel.Item>

          </Carousel>

        </>
    ) 
    
}

export default Hero;